import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = {
  key: 0,
  class: "py-4 px-5 md:px-6 border-b mb-6 flex items-center justify-between"
}
const _hoisted_5 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_6 = {
  key: 1,
  class: "py-4 px-5 md:px-6 border-b mb-6 flex items-center justify-between"
}
const _hoisted_7 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_8 = { class: "w-80 max-w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-xs md:text-sm font-medium text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Full Name "),
  /*#__PURE__*/_createElementVNode("em", { class: "text-red-600" }, "*")
], -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "md:flex flex-wrap mt-3" }
const _hoisted_12 = { class: "md:w-1/2 md:pr-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-xs md:text-sm font-medium text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("em", { class: "text-red-600" }, "*")
], -1)
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = ["readonly"]
const _hoisted_16 = { class: "md:w-1/2 md:pr-12 mt-3 md:mt-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-xs md:text-sm font-medium text-gray-700"
}, " Phone number ", -1)
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "notes",
  class: "block text-xs md:text-sm font-medium text-gray-700"
}, " Notes ", -1)
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "mt-6 flex justify-end" }
const _hoisted_23 = {
  key: 0,
  type: "submit",
  class: "bg-sky text-white text-sm rounded-md py-2 px-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-sky text-white text-sm rounded-md py-2 px-4"
}, " Save changes ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_Wysiwig = _resolveComponent("Wysiwig")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModal('ModalNewOriginator')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
        }, [
          (!_ctx.editor)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, "Create new originator for " + _toDisplayString(_ctx.lender.name), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalNewOriginator')))
                }, [
                  _createVNode(_component_XIcon, { class: "w-5 h-5" })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, "Edit " + _toDisplayString(_ctx.originator.name) + "'s data", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal('ModalNewOriginator')))
                }, [
                  _createVNode(_component_XIcon, { class: "w-5 h-5" })
                ])
              ])),
          _createElementVNode("form", {
            class: _normalizeClass(["px-5 md:px-6 pb-6", { 'opacity-50 pointer-events-none': _ctx.loading }]),
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  id: "name",
                  class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border h-10 px-3 text-sm", { 'border-red-600': _ctx.showAlerts && !_ctx.collectedData.name }]),
                  placeholder: "John Doe",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.name) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "email",
                    id: "email",
                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border h-10 px-3 text-sm", {
                      'border-red-600': _ctx.showAlerts && !_ctx.collectedData.email || _ctx.collectedData.email && !_ctx.isEmailValid,
                      'bg-gray-100': _ctx.editor
                    }]),
                    placeholder: "originator@company.com",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.email) = $event)),
                    readonly: _ctx.editor
                  }, null, 10, _hoisted_15), [
                    [_vModelText, _ctx.collectedData.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "phone",
                    id: "phone",
                    class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md border h-10 px-3 text-sm",
                    placeholder: "+1 (123) 456-7890",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collectedData.phone) = $event))
                  }, null, 512), [
                    [_directive_maska, '+1 (###) ###-####'],
                    [_vModelText, _ctx.collectedData.phone]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Wysiwig, {
                  modelValue: _ctx.collectedData.description,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.collectedData.description) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (!_ctx.editor)
                ? (_openBlock(), _createElementBlock("button", _hoisted_23, " Create originator "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "bg-white text-dark text-sm rounded-md py-2 px-4 border mr-2",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal('ModalNewOriginator')))
                    }, " Cancel "),
                    _hoisted_24
                  ], 64))
            ])
          ], 34)
        ])
      ])
    ])
  ]))
}